export const MembershipStatus = {
    Active: "active",
    ExpiringSoon: "expiringSoon",
    Expired: "expired",
};
export const EXPIRING_SOON_DAYS = 30;
export const AUTO_RENEW_GRACE_DAYS = 3;
const toUtcDay = (date) => typeof date === "string" ? date.slice(0, 10) : date.toISOString().slice(0, 10);
const addUtcDays = (utcDay, days) => {
    const date = new Date(`${utcDay}T00:00:00.000Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return toUtcDay(date);
};
export const computeMembershipStatus = (expirationDate, automaticRenewal, now = new Date()) => {
    if (!expirationDate) {
        return MembershipStatus.Active;
    }
    const expirationDay = toUtcDay(expirationDate);
    const today = toUtcDay(now);
    if (automaticRenewal) {
        return addUtcDays(expirationDay, AUTO_RENEW_GRACE_DAYS) < today
            ? MembershipStatus.Expired
            : MembershipStatus.Active;
    }
    if (expirationDay < today) {
        return MembershipStatus.Expired;
    }
    return expirationDay <= addUtcDays(today, EXPIRING_SOON_DAYS)
        ? MembershipStatus.ExpiringSoon
        : MembershipStatus.Active;
};
